import {
  ComponentFactoryResolver,
  ComponentRef,
  ElementRef,
  EmbeddedViewRef,
  Injectable,
  Injector,
  Type,
} from '@angular/core';
import { elementToStyledHtml } from './core/dom';

@Injectable()
export class DocumentGeneratorService {
  constructor(
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    private readonly injector: Injector,
  ) {}

  generate<T>(
    componentConstructor: Type<T>,
    updateInstance: (instance: ComponentRef<T>['instance']) => void,
  ): string {
    const component = this.componentFactoryResolver
      .resolveComponentFactory(componentConstructor)
      .create(this.injector);
    updateInstance(component.instance);
    component.changeDetectorRef.detectChanges();
    const view = <EmbeddedViewRef<unknown>>component.hostView;
    const element: HTMLElement = view.rootNodes[0];
    document.body.appendChild(element);
    try {
      return elementToStyledHtml(element);
    } finally {
      document.body.removeChild(element);
    }
  }

  generateFromExistingComponent(component: ElementRef): string {
    return elementToStyledHtml(component.nativeElement);
  }
}
